export const enums = {
    EmploymentTypeEnum: [
        "fullEmployment",
        "underemployment",
        "remote",
        "trainingAndPractice",
        "projectWork",
        "relocate",
        "temporaryWork",
        "combined",
        "shiftWork"
    ],
    CurrencyTypeEnum: [
        "USD",
        "EUR",
        "UAH",
        "RUB",
        "ARS",
        "AUD",
        "BRL",
        "BYN",
        "CAD",
        "CNY",
        "GBP",
        "HKD",
        "IDR",
        "INR",
        "JPY",
        "KZT",
        "LKR",
        "MXN",
        "MYR",
        "PHP",
        "PLN",
        "RMB",
        "SGD",
        "THB",
        "ZAR",
        "KRW",
        "EGP",
        "UZS",
        "KGS",
        "MDL",
        "AZN",
        "RON",
        "COP",
        "GEL",
        "AMD",
        "CZK"
    ],
    ExperienceEnum: [
        "e00_no_experience",
        "e01_less_than1year",
        "e1_1year",
        "e2_2years",
        "e3_3years",
        "e4_4years",
        "e5_5years",
        "e6_10years"
    ],
    CandidateSourceEnum: [
        "add_manually",
        "add_from_recommendation",
        "add_from_email",
        "add_from_recall",
        "add_from_linkedinNew",
        "add_from_hh",
        "add_from_workua",
        "add_from_rabotaua",
        "add_from_superjob",
        "add_from_djinni",
        "add_from_cvlv",
        "add_from_jobstutby",
        "add_from_jobkg",
        "add_from_google_drive",
        "add_from_rabotauz",
        "add_from_dou",
        "add_from_excel",
        "add_from_archive",
        "add_from_grc"
    ],
    SortEnum: [
        "dc",
        "dm",
        "relevance",
        "lastCommentDate",
        "hireDate",
        "alphabetically",
        "lastName",
        "status",
        "city",
        "clientName",
        "priority",
        "dateFinish",
        "scoreCard",
        "gdpr",
    ],
    SortOrderEnum: [
        "ASC",
        "DESC",
    ],
    AccessTypeEnum: [
        "private",
        "public"
    ],
    InterviewStatusEnum: [
        "in_process",
        "rejects",
        "accept"
    ],
    ObjectEnum: [
        "client",
        "vacancy",
        "candidate",
        "task",
        "candidate_attachment",
        "client_attachment",
        "vacancy_attachment",
        "avatar",
        "vacancy_application",
    ],
    RoleEnum: [
        "freelancer",
        "researcher",
        "recruter",
        "client",
        "admin"
    ],
    ClientStateEnum: [
        "future",
        "in_work",
        "all_done",
        "canceled",
        "deleted",
        "on_hold"
    ],
    LanguageLvEnum: [
        "Basic",
        "Pre_Intermediate",
        "Intermediate",
        "Upper_Intermediate",
        "Advanced",
        "Proficient",
        "Native",
    ],
    FieldTypeEnum : [
        "text",
        "select",
        "string",
        "date",
        "datetime"
    ],
    CandidateStateEnum : [
        "not_searching",
        "passive_search",
        "active_search",
        "employed",
        "work",
        "freelancer",
        "archived",
        "deleted",
        "reserved",
        "black_list",
        "only_remote",
        "only_relocation_abroad"
    ], ActionTypeEnum : [
        "candidate_add",
        "candidate_add_manually",
        "candidate_add_from_linkedin",
        "candidate_add_from_workua",
        "candidate_add_from_email",
        "candidate_add_from_rabotaua",
        "candidate_add_from_archive",
        "candidate_add_from_excel",
        "candidate_add_from_hh",
        "candidate_add_from_djinni",
        "candidate_update_from_excel",
        "candidate_update_from_file",
        "candidate_update_from_workua",
        "candidate_update_from_archive",
        "candidate_update_from_rabotaua",
        "candidate_update_from_linkedinNew",
        "candidate_edit",
        "candidate_edit_from_email",
        "candidate_edit_contacts",
        "candidate_add_file",
        "candidate_add_to_group",
        "candidate_message",
        "candidate_change_state",
        "candidate_set_responsible",
        "candidate_message_for_hm",
        "candidate_sent_email",
        "candidate_edit_group",
        "candidate_remove_from_group",
        "candidate_merge_group",
        "candidate_edit_pdcs",
        "interview_add",
        "interview_add_from_rabotaUa",
        "interview_add_from_workUa",
        "interview_edit",
        "interview_message",
        "interview_remove",
        "task_create",
        "task_change_status",
        "vacancy_change_state",
        "vacancy_add",
        "vacancy_edit",
        "vacancy_set_responsible",
        "remove_candidate_group",
        "set_interview_status",
    ],
    InterviewStateEnum : [
        "interview",
        "applied_people",
        "shortlist",
        "longlist",
        "notafit",
        "declinedoffer",
        "offer_declined",
        "probation_failure",
        "is_not_looking_for_job",
        "approved",
        "interview_with_the_boss",
        "tech_interview",
        "hr_interview",
        "interview_with_the_client",
        "job_offer",
        "test_task",
        "security_check",
        "tech_screen",
        "sent_offer",
        "accept_offer",
        "invite_to_interview",
        "interview_scheduled",
        "interview_conducted",
        "rejected",
        "no_response",
        "no_contacts",
        "accepted_counter_offer",
        "found_another_job",
        "open",
        "disqualified",
    ]
}